import Swiper from 'swiper';
import { Navigation, Pagination, EffectCreative, Autoplay } from 'swiper/modules';

// 1. Correct way to register modules in modern Swiper
const logoSlider = new Swiper('.logo-slider', {
  modules: [Pagination, Navigation, EffectCreative, Autoplay],
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 40,
  speed: 4000,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  allowTouchMove: false,
});

// 2. REMOVED manual slide cloning code.
// Swiper handles all necessary slide duplication internally when loop: true is set.
